export default __webpack_public_path__ + "static/media/icons_requests.0ed774b2.svg";